var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Time_Icon",
    "data-name": "Time Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1962",
    "data-name": "Rectangle 1962",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode",
    "data-name": "Isolation Mode",
    transform: "translate(1 1.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6007",
    "data-name": "Path 6007",
    d: "M20.936,10.466A10.476,10.476,0,0,0,10.47,0h-.4A8.935,8.935,0,0,0,9,.1,10.46,10.46,0,1,0,20.808,12.055c.054-.353.086-.712.107-1.07C20.92,10.808,20.936,10.642,20.936,10.466Zm-10.466,9.4A9.39,9.39,0,0,1,9,1.2a8.946,8.946,0,0,1,1.07-.107h.4a9.406,9.406,0,0,1,9.4,9.374c0,.177,0,.348,0,.535a8.973,8.973,0,0,1-.123,1.07A9.4,9.4,0,0,1,10.47,19.861Z",
    transform: "translate(0.21 0.221)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6007_-_Outline",
    "data-name": "Path 6007 - Outline",
    d: "M9.987-.3h.4A10.7,10.7,0,0,1,21.078,10.386c0,.112-.006.218-.012.321,0,.067-.008.136-.01.2v.006c-.025.411-.06.767-.109,1.09A10.681,10.681,0,0,1,10.4,21.054c-.2,0-.4-.006-.6-.017A10.681,10.681,0,0,1,8.889-.2,9.179,9.179,0,0,1,9.983-.3ZM20.615,10.9c0-.073.006-.144.01-.213.006-.1.011-.2.011-.3A10.256,10.256,0,0,0,10.391.142h-.4a8.745,8.745,0,0,0-1.04.094A10.239,10.239,0,0,0,9.824,20.6c.191.011.384.016.575.016A10.24,10.24,0,0,0,20.51,11.942C20.557,11.634,20.591,11.291,20.615,10.9ZM9.986.792h.406a9.627,9.627,0,0,1,9.616,9.594v.548a9.23,9.23,0,0,1-.126,1.1A9.622,9.622,0,0,1,10.4,20h-.011A9.611,9.611,0,0,1,8.885.9a9.2,9.2,0,0,1,1.1-.11Zm9.58,10.124v-.529a9.185,9.185,0,0,0-9.175-9.153h-.4a8.756,8.756,0,0,0-1.039.1,9.169,9.169,0,0,0,1.437,18.224h.01a9.18,9.18,0,0,0,9.044-7.607A8.786,8.786,0,0,0,19.566,10.915Z",
    transform: "translate(0.289 0.3)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6008",
    "data-name": "Path 6008",
    d: "M22.339,15.023H17.165a.535.535,0,0,1-.535-.535V7.045a.535.535,0,1,1,1.07,0v6.908h4.639a.535.535,0,0,1,0,1.07Z",
    transform: "translate(-7.517 -2.806)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6008_-_Outline",
    "data-name": "Path 6008 - Outline",
    d: "M22.26,15.164H17.086a.757.757,0,0,1-.756-.756V6.966a.756.756,0,1,1,1.512,0v6.687H22.26a.756.756,0,1,1,0,1.512ZM17.086,6.652a.315.315,0,0,0-.314.314v7.443a.315.315,0,0,0,.314.314H22.26a.314.314,0,1,0,0-.629H17.4V6.966A.315.315,0,0,0,17.086,6.652Z",
    transform: "translate(-7.438 -2.727)",
    fill: "#525252"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time_icon.80f8460836d03e60513e7f2807f30e21.svg";
export { ForwardRef as ReactComponent };